import { useDispatch, useSelector } from "react-redux";
import { GridActionsCellItem } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import { policies as permessi } from "../../const/policies";
import { useState } from "react";
import useGenerateQrCode from "../../Hooks/useGenerateQrCode";
import useMobileDetection from "../../Hooks/useMobileDetection";
import { GenerateQrCodePostazione } from "../../const/urlAction";
import { faBan, faPen, faQrcode, faRotateRight, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { Typography, Menu, Box, IconButton, MenuItem, ListItemIcon, Divider, ListItemText } from "@mui/material";
import { handleDialogToEditPostazioni } from "./operations/handleDialogToEditPostazioni";
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import { setScrollY } from "../../redux/reducers/scroll-reducer";


const ButtonBoxPostazioni = ({ row: rowInfo, inSubmenu = false }) => {
  const configuration = useSelector((state) => state.configurations.configurazioniGlobali);
  const { enableQrCodeScanner, qrCodeDinamico } = configuration;
  const isSalaRiunione = rowInfo?.isSalaRiunione;
  const [isLoading, setIsLoading] = useState(false);
  const state = useSelector((state) => state.userDate);
  const { policies, responsabileEdificio } = state;
  const dispatch = useDispatch();
  const viewState = useSelector((state) => state.viewState);
  const isMobile = useMobileDetection(600);
  const { t } = useTranslation();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const menuOpen = Boolean(menuAnchorEl);

  const handleMenuClick = (event) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    dispatch(setScrollY(document.querySelector("main.MuiBox-root").scrollTop));

  };

  const handleDownloadQrCode = useGenerateQrCode(setIsLoading, GenerateQrCodePostazione);
  const actionButtonStyle = {
    border: "1px solid #dcdcdc",
    borderRadius: "4px",
    padding: "4px 8px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "#eae5e591",
    cursor: "pointer",
    minWidth: "78px",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
      borderColor: "#3e6bb4",
    },
  };

  return (
    <>
      {inSubmenu ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', pb: 1 }}>
          {policies.indexOf(permessi.postazioniInserimentoModifica) !== -1 && (
            <MenuItem onClick={() => handleDialogToEditPostazioni({ dialogType: "editUtenti", rowInfo }, dispatch)}>
              <ListItemIcon><FontAwesomeIcon icon={faPen} /></ListItemIcon>
              <ListItemText primary={t("edit")} />
            </MenuItem>
          )}
          {!isSalaRiunione && policies.indexOf(permessi.postazioniEliminazioneRipristino) !== -1 && (
            <MenuItem onClick={() => handleDialogToEditPostazioni({ dialogType: "delete", rowInfo }, dispatch)}>
              <ListItemIcon><FontAwesomeIcon icon={faTrash} /></ListItemIcon>
              <ListItemText primary={t("delete")} />
            </MenuItem>
          )}
          {enableQrCodeScanner && (!qrCodeDinamico || !rowInfo?.nominativoDevice) &&
            (policies.indexOf(permessi.postazioniDownloadQRCode) !== -1 || responsabileEdificio.length > 0) && (
              <>
                <MenuItem onClick={() => handleDownloadQrCode({ id: rowInfo.id, qrCodePostazione: rowInfo.qrCodePostazione })}>
                  <ListItemIcon><FontAwesomeIcon icon={faQrcode} /></ListItemIcon>
                  <ListItemText primary={t("download_qr_code")} />
                </MenuItem>
                <Divider />
              </>
            )}
          {(policies.indexOf(permessi.postazioniEliminazioneRipristino) !== -1 || responsabileEdificio.length > 0) && (
            <>
              <MenuItem onClick={() => handleDialogToEditPostazioni({ dialogType: "disableOne", rowInfo }, dispatch)}>
                <ListItemIcon><FontAwesomeIcon icon={faBan} /></ListItemIcon>
                <ListItemText primary={t("disable_v3")} />
              </MenuItem>
              <MenuItem onClick={() => handleDialogToEditPostazioni({ dialogType: "restoreOne", rowInfo }, dispatch)}>
                <ListItemIcon><FontAwesomeIcon icon={faRotateRight} /></ListItemIcon>
                <ListItemText primary={t("restore_v2")} />
              </MenuItem>
            </>
          )}
        </Box>
      ) : !isMobile && !viewState ? (
        <>
          <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
            <Tooltip title={t("actions")}>
              <IconButton
                onClick={(e) => {
                  handleMenuClick(e);
                }}
                size="small"
                sx={{
                  mr: 2,
                  width: 40,
                  height: 40,
                  borderRadius: "50%",
                }}
                aria-controls={menuOpen ? 'actions-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={menuOpen ? 'true' : undefined}
              >
                <FontAwesomeIcon icon={faEllipsisV} size="lg" />
              </IconButton>
            </Tooltip>
          </Box>
          <Menu
            anchorEl={menuAnchorEl}
            id="actions-menu"
            open={menuOpen}
            onClick={handleMenuClose}
            onClose={handleMenuClose}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            slotProps={{
              paper: {
                elevation: 2,
                sx: {
                  mt: 1,
                  borderRadius: "10px",
                  minWidth: 200,
                },
              },
            }}
          >

            {/* 🔹 EDIT */}
            {policies.indexOf(permessi.postazioniInserimentoModifica) !== -1 && (
              <>
                <MenuItem
                  onClick={() =>
                    handleDialogToEditPostazioni({ dialogType: "editUtenti", rowInfo }, dispatch)
                  }
                >
                  <ListItemIcon>
                    <FontAwesomeIcon icon={faPen} />
                  </ListItemIcon>
                  <ListItemText primary={t("edit")} />
                </MenuItem>
              </>
            )}
            {/* 🔹 DELETE */}
            {!isSalaRiunione &&
              policies.indexOf(permessi.postazioniEliminazioneRipristino) !== -1 && (
                <MenuItem
                  onClick={() =>
                    handleDialogToEditPostazioni({ dialogType: "delete", rowInfo }, dispatch)
                  }
                >
                  <ListItemIcon>
                    <FontAwesomeIcon icon={faTrash} />
                  </ListItemIcon>
                  <ListItemText primary={t("delete")} />
                </MenuItem>
              )}
            {/* 🔹 QR CODE */}
            {enableQrCodeScanner && (!qrCodeDinamico || !rowInfo?.nominativoDevice) &&
              (policies.indexOf(permessi.postazioniDownloadQRCode) !== -1 ||
                responsabileEdificio.length > 0) && (
                <>
                  <MenuItem
                    onClick={() =>
                      handleDownloadQrCode({ id: rowInfo.id, qrCodePostazione: rowInfo.qrCodePostazione })
                    }
                  >
                    <ListItemIcon>
                      <FontAwesomeIcon icon={faQrcode} />
                    </ListItemIcon>
                    <ListItemText primary={t("download_qr_code")} />
                  </MenuItem>
                  <Divider />
                </>
              )}

            {/* 🔹 DISABLE / RESTORE */}
            {(policies.indexOf(permessi.postazioniEliminazioneRipristino) !== -1 ||
              responsabileEdificio.length > 0) && (
                <>
                  <MenuItem
                    onClick={() =>
                      handleDialogToEditPostazioni({ dialogType: "disableOne", rowInfo }, dispatch)
                    }
                  >
                    <ListItemIcon>
                      <FontAwesomeIcon icon={faBan} />
                    </ListItemIcon>
                    <ListItemText primary={t("disable_v3")} />
                  </MenuItem>

                  <MenuItem
                    onClick={() =>
                      handleDialogToEditPostazioni({ dialogType: "restoreOne", rowInfo }, dispatch)
                    }
                  >
                    <ListItemIcon>
                      <FontAwesomeIcon icon={faRotateRight} />
                    </ListItemIcon>
                    <ListItemText primary={t("restore_v2")} />
                  </MenuItem>
                </>
              )}
          </Menu>
        </>
      ) : (
        <>
          {(policies.indexOf(permessi.postazioniEliminazioneRipristino) !== -1 ||
            responsabileEdificio.length > 0) && (
              <GridActionsCellItem
                sx={{ '& .MuiTouchRipple-root': { display: 'none' } }}
                className={isMobile || viewState ? "button-ButtonBox-Mobile forceNoPaddingLeft" : ""}
                icon={
                  <Tooltip title={t("disable")}>
                    <div style={actionButtonStyle}>
                      <>
                        <FontAwesomeIcon icon={faBan} size="xs" style={{ color: "#636161", marginRight: "3px" }} />
                        <Typography sx={{ fontSize: 10, color: "#636161" }}>{t("disable_v3")}</Typography>
                      </>
                    </div>
                  </Tooltip>
                }
                label={t("user")}
                onClick={() =>
                  handleDialogToEditPostazioni({ dialogType: "disableOne", rowInfo }, dispatch)
                }
              />
            )}

          {(policies.indexOf(permessi.postazioniEliminazioneRipristino) !== -1 ||
            responsabileEdificio.length > 0) && (
              <GridActionsCellItem
                sx={{ '& .MuiTouchRipple-root': { display: 'none' } }}
                className={isMobile ? "button-ButtonBox-Mobile" : ""}
                icon={
                  <Tooltip title={t("restore")}>
                    <div style={actionButtonStyle}>
                      <FontAwesomeIcon icon={faRotateRight} size="xs" style={{ color: "#636161", marginRight: "3px" }} />
                      <Typography sx={{ fontSize: 10, color: "#636161" }}>{t("restore_v2")}</Typography>
                    </div>
                  </Tooltip>
                }
                label={t("user")}
                onClick={() => {
                  dispatch(setScrollY(document.querySelector("main.MuiBox-root").scrollTop));
                  handleDialogToEditPostazioni({ dialogType: "restoreOne", rowInfo }, dispatch)
                }
                }
              />
            )}

          {!isSalaRiunione &&
            policies.indexOf(permessi.postazioniEliminazioneRipristino) !== -1 && (
              <GridActionsCellItem
                sx={{ '& .MuiTouchRipple-root': { display: 'none' } }}
                className={isMobile ? "button-ButtonBox-Mobile" : ""}
                icon={
                  <Tooltip title={t("delete")}>
                    <div style={actionButtonStyle}>
                      <FontAwesomeIcon icon={faTrash} size="xs" style={{ color: "#636161", marginRight: "3px" }} />
                      <Typography sx={{ fontSize: 10, color: "#636161" }}>{t("delete_v3")}</Typography>
                    </div>
                  </Tooltip>
                }
                label={t("delete")}
                onClick={() =>
                  handleDialogToEditPostazioni({ dialogType: "delete", rowInfo }, dispatch)
                }
              />
            )}
          {enableQrCodeScanner && (!qrCodeDinamico || !rowInfo?.nominativoDevice) &&
            (policies.indexOf(permessi.postazioniDownloadQRCode) !== -1 ||
              responsabileEdificio.length > 0) && (
              <GridActionsCellItem
                sx={{ '& .MuiTouchRipple-root': { display: 'none' } }}
                className={isMobile || viewState ? "button-ButtonBox-Mobile forceNoPaddingLeft" : ""}
                icon={
                  <Tooltip title={t("download_qr_code")}>
                    <div style={actionButtonStyle}>
                      <>
                        <FontAwesomeIcon icon={faQrcode} size="xs" style={{ color: "#636161", marginRight: "3px" }} />
                        <Typography sx={{ fontSize: 10, color: "#636161" }}>{t("download_qr_code")}</Typography>
                      </>
                    </div>
                  </Tooltip>
                }
                label={t("download_qr_code")}
                onClick={() => handleDownloadQrCode({ id: rowInfo.id, qrCodePostazione: rowInfo.qrCodePostazione })}
              />
            )}
        </>
      )}
    </>
  );
};

export default ButtonBoxPostazioni;
